const initialState =
 {  
    loading: false, 
    error:false,
    message:"",
    marcas:[],
    mes:0,
    nameMarca:"",
    nameUnidad:"",
    idMarca:0,
    idUnidad:0,
    dataInventarioNuevos:[],
    dataInventarioSeminuevos:[],
    dataVentaNuevos:[],
    keysVentaNuevos:[],
    dataVentaSeminuevos:[],
    keysVentaSeminuevos:[],
    dataVentaServicioPublico:[],
    keysVentaServicioPublico:[],
    dataVentaServicioPublicoLyP:[],
    keysVentaServicioPublicoLyP:[],
    dataOrdenesProcesoPublico:[],
    dataTipoOrdenesProceso:[],
    dataTipoOrdenesProcesoLyP:[],
    dataOrdenesProcesoPublicoLyP:[],
    dataClasificacionRefacciones:[],
    dataTemoc:[],
    dataTemof:[]
 }

export default (state = initialState, action) => {
    switch (action.type) {
       case "LOADING_MAIN_DASHBOARD":
            return { ...state,loading:action.payload,error:false,message:""};
       case "READY_GLOBAL_DATA_MAIN_DASHBOARD":
            return { ...state,loading:false,error:false,marcas:action.payload};
        case "READY_CHARTS_DATA_MAIN_DASHBOARD":
            return { ...state,loading:false,error:false,dataInventarioNuevos:action.payload.dataInventarioNuevos,
                    dataInventarioSeminuevos:action.payload.dataInventarioSeminuevos,dataVentaNuevos:action.payload.dataVentaNuevos,keysVentaNuevos:action.payload.keysVentaNuevos,
                    dataVentaSeminuevos:action.payload.dataVentaSeminuevos,keysVentaSeminuevos:action.payload.keysVentaSeminuevos,
                    dataVentaServicio:action.payload.dataVentaServicio,keysVentaServicioPublico:action.payload.keysVentaServicioPublico,
                    dataVentaServicioPublicoLyP:action.payload.dataVentaServicioPublicoLyP,keysVentaServicioPublicoLyP:action.payload.keysVentaServicioPublicoLyP,
                    dataOrdenesProcesoPublico:action.payload.dataOrdenesProcesoPublico,
                    dataTipoOrdenesProceso:action.payload.dataTipoOrdenesProceso,
                    dataTipoOrdenesProcesoLyP:action.payload.dataTipoOrdenesProcesoLyP,
                    dataOrdenesProcesoPublicoLyP:action.payload.dataOrdenesProcesoPublicoLyP,
                    dataClasificacionRefacciones:action.payload.dataClasificacionRefacciones,
                    dataCardClasificacionRefaciones:action.payload.dataCardClasificacionRefaciones,
                    dataTemoc:action.payload.dataTemoc,
                    dataTemof:action.payload.dataTemof};
       case "CHANGE_MARCA_MAIN_DASHBOARD":
            return { ...state,nameMarca:action.payload.nameMarca,nameUnidad:action.payload.nameUnidad,
                    idMarca:action.payload.idMarca,idUnidad:action.payload.idUnidad,mes:action.payload.mes};
       case "ERROR_MAIN_DASHBOARD":
            return { ...state,loading:false,error:true,message:action.payload};
       default:
    }
    return state;
}